import { render, staticRenderFns } from "./QuestionaryQuestionTableItem.vue?vue&type=template&id=db71e436&scoped=true&"
import script from "./QuestionaryQuestionTableItem.vue?vue&type=script&lang=ts&"
export * from "./QuestionaryQuestionTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionaryQuestionTableItem.vue?vue&type=style&index=0&id=db71e436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db71e436",
  null
  
)

export default component.exports